import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React from 'react';
import MarkdownEditor from './markdown-editor';
import SimpleEditor from './simple-editor';
import PlainMarkdownEditor from './plain-markdown-editor';
import LoadScript from './load-script';
import EditorBuilder from './editor-builder';

var SimpleEditorWithErrorBoundary = /*#__PURE__*/function (_React$Component) {
  _inherits(SimpleEditorWithErrorBoundary, _React$Component);

  var _super = _createSuper(SimpleEditorWithErrorBoundary);

  function SimpleEditorWithErrorBoundary() {
    _classCallCheck(this, SimpleEditorWithErrorBoundary);

    return _super.apply(this, arguments);
  }

  _createClass(SimpleEditorWithErrorBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error) {
      console.error(error);
      this.forceUpdate();
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SimpleEditor, this.props);
    }
  }]);

  return SimpleEditorWithErrorBoundary;
}(React.Component);

var MarkdownEditorWithErrorBoundary = /*#__PURE__*/function (_React$Component2) {
  _inherits(MarkdownEditorWithErrorBoundary, _React$Component2);

  var _super2 = _createSuper(MarkdownEditorWithErrorBoundary);

  function MarkdownEditorWithErrorBoundary() {
    _classCallCheck(this, MarkdownEditorWithErrorBoundary);

    return _super2.apply(this, arguments);
  }

  _createClass(MarkdownEditorWithErrorBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error) {
      console.error(error);
      this.forceUpdate();
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(LoadScript, {
        scriptSource: this.props.scriptSource
      }, /*#__PURE__*/React.createElement(MarkdownEditor, this.props));
    }
  }]);

  return MarkdownEditorWithErrorBoundary;
}(React.Component);

var PlainMarkdownEditorWithErrorBoundary = /*#__PURE__*/function (_React$Component3) {
  _inherits(PlainMarkdownEditorWithErrorBoundary, _React$Component3);

  var _super3 = _createSuper(PlainMarkdownEditorWithErrorBoundary);

  function PlainMarkdownEditorWithErrorBoundary() {
    _classCallCheck(this, PlainMarkdownEditorWithErrorBoundary);

    return _super3.apply(this, arguments);
  }

  _createClass(PlainMarkdownEditorWithErrorBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error) {
      console.error(error);
      this.forceUpdate();
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(LoadScript, {
        scriptSource: this.props.scriptSource
      }, /*#__PURE__*/React.createElement(PlainMarkdownEditor, this.props));
    }
  }]);

  return PlainMarkdownEditorWithErrorBoundary;
}(React.Component);

export { EditorBuilder, MarkdownEditorWithErrorBoundary as MarkdownEditor, SimpleEditorWithErrorBoundary as SimpleEditor, PlainMarkdownEditorWithErrorBoundary as PlainMarkdownEditor };